<div class="card bg-light concept-attributes" *ngIf="attributes">
  <div class="card-body {{ bodyClass }}">
    <ng-content></ng-content>
    <p *ngFor="let k of attributes | keys">
      <strong>{{ k }}:&nbsp;</strong>{{ attributes[k] | json }}
    </p>
  </div>
</div>
